<div class="contactedit-component" data-hook="contactedit-component">
  <div class="row">
    <!-- Geschlecht -->
    <div class="form-group col-xs-12 col-md-6">
      <label for="gender1">Geschlecht</label>
      <div class="radio">
        <label for="gender1" class="radio-inline">
          <input type="radio" value="weiblich" tabindex="0"
                 ng-model="vm.contactdata.gender"
                 ng-change="vm.save()"
                 id="gender1">weiblich</label>
        <label for="gender2" class="radio-inline">
          <input type="radio" value="männlich" tabindex="0"
                 ng-model="vm.contactdata.gender"
                 ng-change="vm.save()"
                 id="gender2">männlich</label>
        <label for="gender3" class="radio-inline">
          <input type="radio" value="unbekannt" tabindex="0"
                 ng-model="vm.contactdata.gender"
                 ng-change="vm.save()"
                 id="gender3">unbekannt</label>
      </div>
    </div>
    <div class="form-group col-xs-12 col-md-6">
      <div ng-show="vm.showrelation">
        <label for="relation">Bezug zum primären Kontakt</label>
        <vcinput model="vm.contactdata.relation" id="relation" placeholder="Bezug"
                 parentsave="vm.childsave(key, value)"></vcinput>
      </div>
    </div>
  </div>

  <!-- Titel, Name -->
  <div class="row">
    <div class="form-group col-xs-12 col-md-2">
      <label for="titlefront">Titel</label>
      <vcinput model="vm.contactdata.titlefront" id="titlefront" parentsave="vm.childsave(key, value)"></vcinput>
    </div>
    <div class="form-group col-xs-12 col-md-4">
      <label for="firstname">Vorname</label>
      <vcinput model="vm.contactdata.firstname" id="firstname" placeholder="Vorname"
               parentsave="vm.childsave(key, value)"></vcinput>
    </div>
    <div class="form-group col-xs-12 col-md-4">
      <label for="lastname">Nachname</label>
      <vcinput model="vm.contactdata.lastname" id="lastname" placeholder="Nachname"
               parentsave="vm.childsave(key, value)"></vcinput>
    </div>
    <div class="form-group col-xs-12 col-md-2">
      <label for="titleback">Titel</label>
      <vcinput model="vm.contactdata.titleback" id="titleback" parentsave="vm.childsave(key, value)"></vcinput>
    </div>
  </div>


  <!-- Adresse -->
  <div class=" row">
    <div class="form-group col-xs-12">
      <label for="address">Adresse</label>
      <vcinput model="vm.contactdata.address" id="address" placeholder="Adresse"
               parentsave="vm.childsave(key, value)"></vcinput>
    </div>
  </div>

  <!-- PLZ & Ort, Land -->
  <div class="row">
    <div class="form-group col-xs-12 col-md-6">
      <zipcode zip="vm.contactdata.postcode" parentsave="vm.zipsave(zip, city)" city="vm.contactdata.city" ti="0"
               ti2="0"></zipcode>
    </div>
    <!-- Land -->
    <div class="form-group col-xs-12 col-md-6" ng-init="vm.contactdata.country='Österreich'">
      <label for="country">Land</label>
      <!--      <input type="text" ng-model="vm.contactdata.country" tabindex="0"
                   ng-blur="vm.save()"
                   class="form-control" id="country" value="Österreich">-->
      <vcinput model="vm.contactdata.country" id="country" parentsave="vm.childsave(key, value)">
    </div>
  </div>


  <div class="row">
    <!-- Mobil -->
    <div class="form-group col-xs-12 col-md-6">
      <label for="phone">Mobiltelefon</label>
      <!--      <input type="text" ng-model="vm.contactdata.phone" tabindex="0"
                   ng-blur="vm.save()"
                   class="form-control" id="phone" placeholder="Mobilnummer">-->
      <vcinput model="vm.contactdata.phone" id="phone" placeholder="Mobilnummer"
               parentsave="vm.childsave(key, value)"></vcinput>
    </div>
    <!-- Festnetz -->
    <div class="form-group col-xs-12 col-md-6">
      <label for="landline">Festnetz/2. Mobiltelefon</label>
      <!--      <input type="text" ng-model="vm.contactdata.landline" tabindex="0"
                   ng-blur="vm.save()"
                   class="form-control" id="landline" placeholder="Festnetznummer">-->
      <vcinput model="vm.contactdata.landline" id="landline" placeholder="Festnetznummer"
               parentsave="vm.childsave(key, value)"></vcinput>
    </div>
  </div>

  <div class="row">
    <!-- E-Mail -->
    <div class="form-group col-xs-12 col-md-6">
      <label for="email">E-Mail</label>
      <!--      <input type="email" ng-model="vm.contactdata.email" tabindex="0"
                   ng-blur="vm.save()"
                   class="form-control" id="email" placeholder="E-Mail">-->
      <vcinput model="vm.contactdata.email" id="email" placeholder="E-Mail"
               parentsave="vm.childsave(key, value)"></vcinput>
    </div>
    <!-- Fax -->
    <div class="form-group col-xs-12 col-md-6">
      <label for="fax">Fax</label>
      <!--      <input type="text" ng-model="vm.contactdata.fax" tabindex="0"
                   ng-blur="vm.save()"
                   class="form-control" id="fax" placeholder="Fax">-->
      <vcinput model="vm.contactdata.fax" id="fax" placeholder="Fax" parentsave="vm.childsave(key, value)"></vcinput>
    </div>
  </div>
</div>